// extracted by mini-css-extract-plugin
module.exports = {"menu":"_fab65c","paper":"_f53f6b","divider":"_b137d2","icon":"_ca5b59","from":"_817806","leave":"_915e24","enter":"_bc9208"};